<template>
  <div class="position">
    <template v-if="!useTab">
      <div
        v-for="widget in widgets"
        :key="widget.id"
        class="widget"
      >

        <div v-if="!widget.hideTitle">
          <h1 class="module-title-light">
            <template v-if="widget.type == 'npa_last'">
              <router-link
                :to="$i18nRoute({ name: 'search-npa', query: {last: 'npa'} })"
              >{{ widget.title }}
              </router-link>
            </template>
            <template v-else>
              {{ widgetTitle(widget) }}
            </template>
          </h1>
        </div>
        <template v-if="widget.type == 'menu_profile'">
          <MenuProfile :menus="widget.menuItems"/>
        </template>
        <template v-if="widget.type == 'menu'">
          <WidgetMenu :menus="widget.menuItems"/>
        </template>
        <template v-else-if="widget.type == 'npa_category'">
          <NpaCategory :widget="widget"/>
        </template>
        <template v-else-if="widget.type == 'npa_developer'">
          <NpaDeveloper :widget="widget"/>
        </template>
        <template
          v-else-if="
            widget.type == 'npa_last' ||
              widget.type == 'npa_popular' ||
              widget.type == 'npa_expired' ||
              widget.type == 'npa_ends_today'
          "
        >
          <Npa :widget="widget"/>
        </template>
        <template v-else-if="widget.type == 'page_blog'">
          <PageBlog :widget="widget" :page="widget.page"/>
        </template>
        <template v-else-if="widget.type == 'viewed_npas'">
          <ViewedNpas :widget="widget"/>
        </template>
        <template v-else-if="widget.type == 'advertising_carousel'">
          <AdvertisingCarousel :widget="widget"/>
        </template>
        <template v-else-if="widget.type == 'banner_carousel'">
          <Slick :widget="widget"/>
        </template>
        <template v-else-if="widget.type == 'portal_statistics'">
          <PortalStatistics/>
        </template>
        <template v-else-if="widget.type == 'most_popular'">
          <MostPopular/>
        </template>
        <template v-else-if="widget.type == 'rating'">
          <Rating />
        </template>
        <template v-else-if="widget.type == 'counter'">
          <Counter/>
        </template>
        <div v-else-if="widget.type == 'html'" v-html="widget.content.replace('{{YEAR}}', currentYear)"></div>
        <template v-else>
          <!-- Не задан тип виджета -->
        </template>
      </div>
    </template>
    <template v-else>
      <mq-layout mq="laptop">
        <v-tabs grow slider-color="white">
          <v-tab v-for="widget in widgets" :key="widget.id" :title="widget.title">
            {{ widgetTitle(widget) }}
          </v-tab>
          <v-tab-item
            v-for="widget in widgets"
            :key="widget.id"
            :title="widget.title"
          >
            <template v-if="widget.type == 'menu_profile'">
              <MenuProfile :menus="widget.menuItems"/>
            </template>
            <template v-if="widget.type == 'menu'">
              <WidgetMenu :menus="widget.menuItems"/>
            </template>
            <template v-else-if="widget.type == 'npa_category'">
              <NpaCategory :widget="widget"/>
            </template>
            <template v-else-if="widget.type == 'npa_developer'">
              <NpaDeveloper :widget="widget"/>
            </template>
            <template
              v-else-if="
                    widget.type == 'npa_last' ||
                      widget.type == 'npa_popular' ||
                      widget.type == 'npa_expired' ||
                      widget.type == 'npa_ends_today'
                  "
            >
              <Npa :widget="widget"/>
            </template>
            <template v-else-if="widget.type == 'page_blog'">
              <PageBlog :widget="widget" :page="widget.page"/>
            </template>
            <template v-else-if="widget.type == 'viewed_npas'">
              <ViewedNpas :widget="widget"/>
            </template>
            <template v-else-if="widget.type == 'advertising_carousel'">
              <AdvertisingCarousel :widget="widget"/>
            </template>
            <template v-else-if="widget.type == 'banner_carousel'">
              <Slick :widget="widget"/>
            </template>
            <template v-else-if="widget.type == 'portal_statistics'">
              <PortalStatistics/>
            </template>
            <template v-else-if="widget.type == 'most_popular'">
              <MostPopular/>
            </template>
            <template v-else-if="widget.type == 'rating'">
              <Rating />
            </template>
            <template v-else-if="widget.type == 'counter'">
              <Counter/>
            </template>
            <div v-else-if="widget.type == 'html'" v-html="widget.content.replace('{{YEAR}}', currentYear)"></div>
            <div v-else>
              <!-- Не задан тип виджета -->
            </div>
          </v-tab-item>
        </v-tabs>
      </mq-layout>
      <mq-layout mq="mobile">
        <div
          v-for="widget in widgets"
          :key="widget.id"
          class="widget"
          :title="widget.title"
        >
          <h1 class="title-module">{{ widgetTitle(widget) }}</h1>

          <template v-if="widget.type == 'npa_category'">
            <NpaCategory :widget="widget"/>
          </template>
          <template v-else-if="widget.type == 'npa_developer'">
            <NpaDeveloper :widget="widget"/>
          </template>
          <template v-else-if="widget.type == 'page_blog'">
            <PageBlog :widget="widget" :page="widget.page"/>
          </template>
          <template v-else-if="widget.type == 'viewed_npas'">
            <ViewedNpas :widget="widget"/>
          </template>
          <template
            v-else-if="
                    widget.type == 'npa_last' ||
                      widget.type == 'npa_popular' ||
                      widget.type == 'npa_expired' ||
                      widget.type == 'npa_ends_today'
                  "
          >
            <Npa :widget="widget"/>
          </template>
          <template v-else-if="widget.type == 'rating'">
            <Rating />
          </template>
          <template v-else-if="widget.type == 'counter'">
            <Counter/>
          </template>
          <div v-else-if="widget.type == 'html'" v-html="widget.content.replace('{{YEAR}}', currentYear)"></div>
          <div v-else>
            <!-- Не задан тип виджета -->
          </div>
        </div>
      </mq-layout>
    </template>
  </div>
</template>

<script>
import NpaCategory from '@/components/widget/NpaCategory'
import WidgetMenu from '@/components/widget/WidgetMenu'
import MenuProfile from '@/components/widget/MenuProfile'
import NpaDeveloper from '@/components/widget/NpaDeveloper'
import Npa from '@/components/widget/Npa'
import PageBlog from '@/components/widget/PageBlog'
import AdvertisingCarousel from '@/components/widget/AdvertisingCarousel'
import Slick from '@/components/widget/Slick'
import PortalStatistics from '@/components/widget/PortalStatistics'
import MostPopular from '@/components/widget/MostPopular'
import Counter from '@/components/widget/Counter'
import Rating from '@/components/Rating'
import CMS from '@/model/cms'
import ViewedNpas from '@/components/widget/ViewedNpas'

export default {
  components: {
    Npa,
    ViewedNpas,
    WidgetMenu,
    MenuProfile,
    NpaCategory,
    NpaDeveloper,
    AdvertisingCarousel,
    Slick,
    PortalStatistics,
    MostPopular,
    Counter,
    Rating,
    PageBlog
  },
  props: {
    position: {
      type: String,
      required: true
    },
    useTab: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    widgets: [],
    titleLink: false
  }),
  mounted() {
    CMS.loadWidgetByPosition(this.position)
      .then((response) => {
        this.widgets = response.data
      })
      .catch((error) => {
        //@todo ошибки
        // if (typeof error.data !== "undefined" && typeof error.data.error !== "undefined") {
        //     this.$noty.error(String(error.data.error))
        // } else {
        //     this.$noty.error(String(error))
        // }
      })
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {
    widgetTitle(widget) {
      if (widget.type === 'portal_statistics') {
        return `${widget.title} за ${this.currentYear} год`
      }

      return widget.title
    }
  }
}
</script>
